<template>
  <!--门户界面-->
  <div
    :style="{ 'background-image': 'url(' + bgImg + ')' }"
    class="container-layout"
  >
    <div class="container-top">
      <el-row type="flex" justify="start"><el-col :span="3"/>
        <el-col :span="9">
          <el-row type="flex" justify="start" align="middle">
            <el-col :span="8">
              <img  v-if="logoTheme == 'cts'"  :src="logoImg" alt="" class="logo-img" />
              <img  v-if="logoTheme == 'dv'"  :src="logoDvImg" alt="" class="logo-img" />
            </el-col>
    <!--         <el-col :span="19" :offset="2">
              <span class="col-span">
                <i>
                  <img :src="locationIcon" alt="" />
                </i>
                <label>{{ locationName }}</label>
              </span>
            </el-col> -->
          </el-row>
        </el-col>
        <el-col :span="24">
          <ul class="ul-tab" style="float: right">
            <li @click="toBookingAdd()">
              <span class="tab-span">
                 <router-link to="">{{
                   $t("home.booking")
                   }} </router-link>
              </span>
            </li>
            <li @click="toBookingManage()">
              <span class="tab-span">
                <router-link to="">{{
                  $t("home.bookingQuery")
                  }} </router-link>
              </span>
            </li>
            <li v-if="hasLogin==1" @click="routeTo('/dashboard')">
                  <span class="tab-span">
                    <i>
                       <img :src="loginIcon" alt="" />
                    </i>
                    <router-link to="">{{userNameCn}} </router-link>
                  </span>
            </li>
            <li  v-if="hasLogin==0"  @click="routeTo('/login')">
              <span class="tab-span">
                <i>
                  <img :src="loginIcon" alt="" />
                </i>
                <router-link to="">{{
                  $t("home.login")
                  }} </router-link>
              </span>
            </li>
            <li>
              <span class="tab-span">
                <lang-select class="right-menu-item hover-effect"/>
              </span>
            </li>
          </ul>
        </el-col>
        <el-col :span="5" />
      </el-row>
    </div>
    <div class="container-middle">
      <el-row style="width: 100%" type="flex" justify="center">
         <div class="home-page-advertise">
           <img :src="advertise" style="margin-bottom:10px"/>
         </div>
      </el-row>
       <!--      <el-row style="width: 100%" type="flex" justify="center">
        <el-col :span="12">
          <el-row type="flex" justify="center">
            <el-col :span="5" style="text-align: center">
              <label class="label-font" style="font-size: xx-large">专业</label>
            </el-col>
            <el-col :span="5" style="text-align: center">
              <label class="label-font" style="font-size: xx-large">专注</label>
            </el-col>
            <el-col :span="5" style="text-align: center">
              <label class="label-font" style="font-size: xx-large">诚信</label>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row style="width: 100%" type="flex" justify="center">
        <el-col :span="10">
          <div class="line-style" />
        </el-col>
      </el-row>
      <el-row
        style="width: 100%; margin-bottom: 30px"
        type="flex"
        justify="center"
      >
        <el-col :span="10">
          <el-row type="flex" justify="center">
            <el-col :span="24" style="text-align: center">
              <span>
                <label class="label-font label-margin" style="font-size: xx-large">Professional</label>
                <label class="label-font label-margin" style="font-size: xx-large">Focus</label>
                <label class="label-font" style="font-size: xx-large">Integrity</label>
              </span>
            </el-col>
          </el-row>
        </el-col>
      </el-row> -->
      <el-row
        style="width: 100%; margin-bottom: 180px"
        type="flex"
        justify="center"
      >
        <el-col :span="12">
          <el-row type="flex" justify="center" style="margin-bottom: 4px">
            <el-col>
              <label class="query-font" :class="{ 'label1-active': isActive }" @click="trackClick">{{ $t('home.cargoTracking') }}</label>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="22">
              <el-row>
                <el-col v-show="isActive">
                  <el-input
                    class="query-input"
                    style="height: 36px"
                    v-model="queryParam"
                    placeholder="请输入提单号、箱号进行查询"
                  />
                </el-col>
                <el-col v-show="!isActive">
                  <el-form
                    :model="searchData"
                    ref="ruleFormRef"
                    class="form-panel"
                    label-position="top"
                    :validateOnRuleChange="false"
                  >
                    <el-row class="content-panel">
                      <el-row :gutter="22">
                        <el-row :gutter="10" style="margin: 5px">
                          <el-col :span="12">
                            <el-form-item label="船公司:" class="boat">
                              <el-associate
                                style="width: 100%"
                                :columns="associate_columns_carrier"
                                :query-method="associate_queryMethod_carrier"
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="custAlias"
                                value-prop="custNameCn"
                                placeholder=""
                                v-model="searchData.carrierName"
                                size="mini"
                              />
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-row>
                              <el-col :span="16">
                                <el-form-item label="船名/航次:">
                                  <el-associate
                                    style="width: 100%"
                                    :columns="associate_columns_vessel"
                                    :query-method="associate_queryMethod_vessel"
                                    class="input_length"
                                    clearable
                                    :query-length="0"
                                    :default-first-option="true"
                                    label-prop="vesselName"
                                    value-prop="mdVoyagePlanId"
                                    placeholder=""
                                    v-model="searchData.vesselName"
                                    size="mini"
                                    @change="onChangeVessel"
                                  />
                                </el-form-item>
                              </el-col>
                              <el-col :span="8">
                                <el-form-item>
                                  <label slot="label" class="label_no"></label>
                                  <el-associate
                                    style="width: 100%"
                                    :columns="associate_columns_voyage"
                                    :query-method="associate_queryMethod_voyage"
                                    class="input_length"
                                    clearable
                                    :query-length="0"
                                    :default-first-option="true"
                                    label-prop="voyage"
                                    value-prop="voyage"
                                    placeholder=""
                                    v-model="searchData.voyage"
                                    size="mini"
                                    name="voyage"
                                  />
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>

                        </el-row>
                        <el-row :gutter="10" style="margin: 5px">
                           <el-col :span="12">
                            <el-col :span="12">
                              <el-form-item label="装货港:">
                                <el-associate
                                  style="width: 100%"
                                  :columns="associate_columns_po"
                                  :query-method="associate_queryMethod_po"
                                  class="input_length"
                                  clearable
                                  :query-length="0"
                                  :default-first-option="true"
                                  label-prop="portNameEn"
                                  value-prop="portNameEn"
                                  placeholder=""
                                  v-model="searchData.polName"
                                  size="mini"
                                  name="polName"
                                />
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="卸货港:">
                                <el-associate
                                  style="width: 100%"
                                  :columns="associate_columns_po"
                                  :query-method="associate_queryMethod_po"
                                  class="input_length"
                                  clearable
                                  :query-length="0"
                                  :default-first-option="true"
                                  label-prop="portNameEn"
                                  value-prop="portNameEn"
                                  placeholder=""
                                  v-model="searchData.podName"
                                  size="mini"
                                  name="podName"
                                />
                              </el-form-item>
                            </el-col>
                          </el-col>
                          <el-col :span="12">
                            <el-row>
                              <el-col :span="12">
                                <el-form-item label="开航日期从:">
                                  <el-date-picker
                                    v-model="searchData.etdFrom"
                                    align="right"
                                    type="date"
                                    style="width: 100%"
                                    size="mini"
                                    placeholder=""
                                    :picker-options="pickerOptions"
                                  >
                                  </el-date-picker>
                                </el-form-item>
                              </el-col>
                              <el-col :span="12">
                                <el-form-item label="开航日期到:">
                                  <el-date-picker
                                    v-model="searchData.etdTo"
                                    align="right"
                                    type="date"
                                    style="width: 100%"
                                    size="mini"
                                    placeholder=""
                                    :picker-options="pickerOptions"
                                    @change="changeEndEtd"
                                  >
                                  </el-date-picker>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-row>
                    </el-row>
                  </el-form>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="4">
              <button class="query-btn" @click="queryOne" v-show="isActive">
                {{ $t("button.startSearching") }}
              </button>
              <button
                class="query-btn"
                @click="queryShippingDate"
                v-show="!isActive"
              >
                {{ $t("button.startSearching") }}
              </button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="container-bottom">
      <el-row type="flex" justify="center">
        <el-col :span="8">
          <el-row type="flex" justify="center">
            <el-col :span="24" style="text-align: center">
              <label v-if="logoTheme == 'cts'" class="bottom-label-font">CopyRight ©{{ $t('home.ctsCr') }}</label>
              <label v-if="logoTheme == 'dv'" class="bottom-label-font">CopyRight ©{{ $t('home.dvCr') }}</label>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="24" style="text-align: center">
              <label class="bottom-label-font"
                >{{ $t('home.glCr') }} </label
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getLocation } from "@/api/messageApi";
import LangSelect from '@/components/LangSelect/LangSelect.vue'
import { queryCarrierInfo, queryPoInfo, queryVoyageInfo } from "@/api/commonService";
import { getToken } from '@/utils/auth'
export default {
  name: "HomePage",
  components: {
    LangSelect,
  },
  data() {
    return {
      searchData: {
        carrierName: null,
        vesselName: null,
        voyage: null,
        polName: null,
        podName: null,
        etdFrom: null,
        etdTo: null
        // etdFrom: new Date(new Date(new Date(new Date().getTime() - 24*1000*3600*60).toLocaleDateString()).getTime()),
        // etdTo: new Date(new Date(new Date(new Date().getTime() + 24*1000*3600*31).toLocaleDateString()).getTime() + 24*1000*3600 -1)
      },
     /*  bgImg: require("../../assets/images/home_imgs/home-bg.jpg"),
      logoDvImg: require('../../assets/images/login_imgs/logoDv.png'),
      logoImg: require("../../assets/images/home_imgs/logo.png"),
      locationIcon: require("../../assets/images/home_imgs/location-icon.png"),
      loginIcon: require("../../assets/images/home_imgs/login-icon.png"), */
      bgImg: require("../../assets/images/home_imgs/home-bg.jpg"),
      logoDvImg: require('../../assets/images/login_imgs/logo-dv-homepage.png'),
      logoImg: require("../../assets/images/login_imgs/cts-logo-white.png"),
      locationIcon: require("../../assets/images/home_imgs/location-icon.png"),
      loginIcon: require("../../assets/images/home_imgs/login-icon.png"),
      advertise: require("../../assets/images/login_imgs/advertise-white.png"),
      locationName: window.returnCitySN?.cname,
      isActive: true,
      flag: 0,
      queryParam: "",
      ShippingDate: {
        callingPortName: "",
        portDestinationName: "",
      },
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      // 船公司联想控件
      associate_columns_carrier: [
        {
          title: "中文简称",
          field: "custAlias",
        },
        {
          title: "中文全称",
          field: "custNameCn",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
      ],
      // 船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
       // 航次联想控件
      associate_columns_voyage: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
        {
          title: "航次代码",
          field: "voyageCode",
        },
      ],
       //日期设置
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      hasLogin: 1,
      userNameCn: "",
      logoTheme: 'cts'
    };
  },
  computed: {},
  mounted() {
    let _this = this;
    //this.getLocation()
    let self=this
      const hasToken = getToken()
      if(hasToken==null){
        this.hasLogin=0
      }else{
        this.hasLogin=1
        let userInfo=JSON.parse(localStorage.getItem('userInfo'))
        this.userNameCn= userInfo.userNameCn;
      }
    if(localStorage.logoTheme){
      this.logoTheme = localStorage.logoTheme;
    }
 },
  methods: {
    queryShippingDate() {
      let self = this
      console.log(self.searchData)
      const hasToken = getToken()
      if(hasToken) {
        if(self.searchData.etdFrom) self.searchData.etdFrom = self.searchData.etdFrom.getTime()
         if(self.searchData.etdTo) self.searchData.etdTo = self.searchData.etdTo.getTime()
          this.$router.push({
            name: 'ShippingDate',
            query: {
              searchData: self.searchData,
              flag: 1
            }
          })
      } else {
        this.$router.push({
            path: '/login',
            query: {
              searchData: self.searchData,
               flag: 1,
            }
          })
      }
      // this.$router.push('')
    },
    associate_queryMethod_po({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    getLocation() {
      let _this = this;
      getLocation().then((res) => {
        if (res.code === 20000) {
          _this.locationName = res.data.data[0].city;
        } else {
          _this.$coreMethods.message("error", _this.$t("message.location"));
        }
      });
    },
    trackClick() {
      let _this = this;
      _this.isActive = true;
    },
    queryClick() {
      let _this = this;
      _this.isActive = false;
    },
    toBookingManage() {
      let self = this;
      const hasToken = getToken()

      if(hasToken) {
        self.$router.push({
          name: 'bookingManage',
        })
      } else {
        self.$router.push({
          name: 'login',
          query: {
            flag: "bookingManage"
          }
        })
      }
    },
    toBookingAdd() {
      let self = this;
      const hasToken = getToken()

      if(hasToken) {
        self.$router.push({
          path: '/booking/Add',
        })
      } else {
        self.$router.push({
          name: 'login',
          query: {
            flag: "bookingAdd"
          }
        })
      }
    },
    queryOne() {
      let self = this;

      if (self.queryParam === "") {
        self.$coreMethods.message("warning", "请输入查询参数!");
        return;
      }

      const hasToken = getToken()

      if(hasToken) {
        self.$router.push({
          name: 'StatusHistory',
          params: {
            orderNo: self.queryParam
          }
        })
      } else {
        self.$router.push({
          name: 'login',
          params: {
            StatusHistoryParams: self.queryParam
          },
          query: {
            flag: 'StatusHistory'
          }
        })
      }
    },
    // 路由跳转
    routeTo(val) {
      this.$router.push(val);
    },
      changeEndEtd() {
      let self = this;
      self.searchData.etdTo = new Date(self.searchData.etdTo.getTime() + 1000 * 24 * 3600 - 100)
    },
    changeEndTime() {
      let self = this;
      self.searchData.endTime = new Date(self.searchData.endTime.getTime() + 1000 * 24 * 3600 - 100)
    },
    onChangeVessel(value, selectedRows) {
      console.log(selectedRows);
      this.searchData.vesselName = selectedRows.vesselName;
      this.searchData.voyage = selectedRows.voyage;
    },
     associate_queryMethod_vessel({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.vesselName"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "SO",
          isDeleted6: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "SO",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.query-btn {
border: 1px solid white;
}
.el-input,.el-textarea__inner{
  margin:0!important;
}
</style>
